module.exports = __webpack_public_path__ + "static/liz-b90a254b61915dc0ec556fe7b3848ecf.jpg";